<div class ="radio-button">
  <label class="container" [id]="id+'-container'">
    <div [attr.for]="id" [id]="id+'-label'">{{label}}</div>    
    <input type="radio" [name]="groupName" [id]="id" (change)="updateModel()" [value]="value" [(ngModel)]="model">
    <span class="checkmark" [id]="id+'-span'"></span>
  </label>
</div>
